import type { FaireProductEntity } from "../../entity_types/product";

export const p_ap48nqzt3z: FaireProductEntity = {
  token: "p_ap48nqzt3z",
  type: "product",
  name: "ButterBalm Original Sweet Cream",
  brandToken: "b_zjatwgzdwa",
  brandName: "ButterBalm",
  imageUrl:
    "https://cdn.faire.com/fastly/c5300a96834e2a19691e550a11792f85e2c2cb5b9efd28f77790c1767649d852.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f53ed97ff2f9e4ffbb2b9efd4c0af61e40ad8c060a2a25c945a1ba8d205d83d9.png",
    "https://cdn.faire.com/fastly/8be34b1b0c4db6825804f701913d087a356c27ab65d9864025db1c32ed08262f.png",
    "https://cdn.faire.com/fastly/f51d4f10ac57a86d307b26b75559cd1acc57ff873732f256113e18967b17a9ce.jpeg",
    "https://cdn.faire.com/fastly/bf73e99d08528d7a5cbdc62d7dc4c1ceb0a03faf8e77492e6030b1d6da449534.jpeg",
  ],
  priceDollars: 2.5,
  description:
    "Buttery + Delicious. Our Original Sweet Cream Lip Balm is infused with Aloe and Vitamin E to protect, moisturize, and replenish your lips and keep them SMOOOOOTH. Your lips may suck, but this balm doesn’t. \n\nFirst time orders come with a standard display. Large specialized displays can be sourced by request for flagship retailers. ",
  tags: [],
  msrpDollars: 4.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:21:10.296Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
